export default __webpack_public_path__ + "static/media/GEO.f9a66901.svg";